export const CANCEL_UPLOADS = 'fileUpload/CANCEL';

export const cancelUploads = () => ({ type: CANCEL_UPLOADS });
